/** Pick a download filename from Content-Disposition, preferring RFC 5987 filename*. */
export function filenameFromContentDisposition(header: string | null | undefined, fallback: string): string {
  const cd = (header ?? '').trim();
  if (!cd) return fallback;
  const star = cd.match(/filename\*\s*=\s*(?:UTF-8''|utf-8'')([^;]+)/i);
  if (star?.[1]) {
    try {
      const decoded = decodeURIComponent(star[1].trim().replace(/^"(.*)"$/, '$1'));
      if (decoded) return decoded;
    } catch {
      /* fall through */
    }
  }
  const plain = cd.match(/filename\s*=\s*("(?:\\.|[^"])*"|[^;]+)/i);
  if (plain?.[1]) {
    const name = plain[1].trim().replace(/^"(.*)"$/, '$1').replace(/\\"/g, '"');
    if (name) return name;
  }
  return fallback;
}
